
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftRight75 as ObiThreewayAnalogInleftRight75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-right-75.js';
 
 
 

 
 export const ObiThreewayAnalogInleftRight75 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-right-75',
   elementClass: ObiThreewayAnalogInleftRight75Element,
   events: {
     
   }
  });
 
 